import { faPaw } from "@fortawesome/pro-regular-svg-icons";

import Icon from "common/components/Icon";
import CatalogImage from "common/components/CatalogImage";

import TextChip, { TextChipProps } from "client/common/components/content/TextChip";
import Switch from "client/common/components/inputs/Switch";

import { DosageReminderItem, DosageReminderPatient } from "../types";
import { SPECIES_ICONS } from "../constants";

import styles from "../styles/ItemSummary.module.less";

type ItemSummaryProps = {
  patient: DosageReminderPatient;
  item: DosageReminderItem;
  patientChipVariant: TextChipProps["variant"];
  isActive: boolean;
  /** Shows Enable/Disable switch for Edit page */
  onActiveChange: ((isActive: boolean) => void) | null;
};

const ItemSummary = ({
  patient,
  item,
  patientChipVariant,
  isActive,
  onActiveChange,
}: ItemSummaryProps) => {
  const productName = item.product.product_line.name;

  return (
    <div className={styles.summary}>
      <CatalogImage
        image={item.image}
        size="thumbnail"
        alt={productName}
        className={styles.image}
      />
      <div className={styles.details}>
        <span className={styles.name}>{productName}</span>
        <span className={styles.variant}>
          {item.product.name} · {item.name}
        </span>
        <TextChip variant={patientChipVariant}>
          <Icon icon={SPECIES_ICONS[patient.species] ?? faPaw} className={styles.patientIcon} />
          <span className={styles.patientName}>{patient.name}</span>
        </TextChip>
      </div>
      {onActiveChange && (
        <div className={styles.action}>
          <Switch
            value={isActive}
            onChange={onActiveChange}
            label={`Reminders for ${patient.name}`}
          />
        </div>
      )}
    </div>
  );
};

export default ItemSummary;
